// EvaluationForTreatment.js

import React from "react";
import { useState, useEffect, useContext, useRef } from "react";
import { getDBURL, correctTimeZone } from "../Utils/Utils";
import { useFetch } from "use-http";
import { useNavigate } from "react-router-dom";
import { Box, Button, Text, Image, Tip, RadioButton } from "grommet";
import ConfirmPopupWindow from "../Base components/ConfirmPopupWindow";
import DangerPopupWindow from "../Base components/DangerPopupWindow";
import DisqualificationReason from "./DisqualificationReason";
import { updateStateHandler, convertDateToDisplayformat, generateSyncId, usePopupFocus } from "../Utils/Utils";
import useTrapFocus from "../Utils/useTrapFocus";
import StationPopup from "./StationPopup";
import { Trophy, Cycle, UserExpert, SubtractCircle, RadialSelected, CircleInformation} from "grommet-icons";
import EvaluationSummary from "../Base components/EvaluationSummary";
import SheetStateButton from "../Base components/SheetStateButton";
import OpenSummaryButton from "../Base components/OpenSummaryButton";
import IconTooltipButton  from "./IconTooltipButton";
import { useDataContext } from '../Contexts/DataContext';
import { UserContext } from "../../App";
import { useErrorLogger } from './Logger';



const EvaluationForTreatment = (props) => {
    const {station, stationStartRow, treatment, setBestTreatmentNum
        , handleBestTreatment, updatePlantStatus, deleteDisqualReason} = props;
    // console.log("In EvaluationForTreatment props >>  ", props);

    const currentUser = useContext(UserContext);
    const { varietiesList, fieldList } = useDataContext();
    const navigate = useNavigate();
    const { DBlogError } = useErrorLogger();
    const [showConfirmPopup, setShowConfirmPopup] = useState(false);    // Confirm Popup Window
    const [confirmMessage, setConfirmMessage] = useState('');
    const [confirmFuncOnConfirm, setConfirmFuncOnConfirm] = useState('');

    const [dangerPopupOpen, setDangerPopupOpen] = useState(false); // Danger Popup Window
    const [dangerMessage, setDangerMessage] = useState('');
    const [dangerFuncOnConfirm, setDangerFuncOnConfirm] = useState('');  

    // const [open, setOpen] = useState(false); // Confirm Popup Window
    // const [dangerPopupOpen, setDangerPopupOpen] = useState(false); // Danger Popup Window
    const [stationField, setStationField] = useState({Id: '00000000-0000-0000-0000-000000000000', Name: '', });
    
    const [treatmentEvaluations, setTreatmentEvaluations] = useState([]);
    const [selectedEvaluation, setSelectedEvaluation] = useState(null);  // set selected one in set of loaded evaluations(preharvest)

    const [showEvaluationSummary, setShowEvaluationSummary] = useState(false);
    const [evaluationMaxGrade, setEvaluationMaxGrade] = useState(0);
    const [bestEvaluationNum, setBestEvaluationNum] = useState(0);    
    const [bestEvaluationBy, setBestEvaluationBy] = useState('');

    const [treatmentIsDisqualified, setTreatmentIsDisqualified] = useState(0);
    const [treatDisqualCreateDate, setTreatDisqualCreateDate] = useState('');
    

    const [showDisqualificationReason, setShowDisqualificationReason] = useState(false);
    const [disqualYear, setDisqualYear] = useState(null);

    // Ref for the modal and focus trap to keep focus within it  
    const modalRef = useRef(null);
    useTrapFocus(modalRef, true); // Trap focus inside the modal while it's open

    // Manage focus when opening modal windows
    usePopupFocus(dangerPopupOpen, "danger-msg");
    usePopupFocus(showConfirmPopup, "confirm-msg");
    usePopupFocus(showEvaluationSummary, "eval-summ");
    usePopupFocus(showDisqualificationReason, "disqual-reas");
    
    // console.log("plant >>  ", plant);

    const initEvaluationColorState = () => {
        return [
            {
                sheetID: null,
                sheetStatus: null,
                gradeColor: "status-unknown",
                evaluationGrade: 0,
                evaluationProgress: 0,
                evaluationYear: null,
                createDate: null,
                treatmentId: null,
                teatmentStatus: null,
                teatmentYear: null,            
                sheetColor: "status-unknown",
                sheetName: "new evaluation"
            },
        ];
    }
    const [sheetColor, setSheetColor] = useState(initEvaluationColorState());
    
    const { get, post } = useFetch(
        getDBURL()
    );  

    useEffect(() => {
        // get all evaluations for treatment
        (async function loadEvaluationsByTreatment() {
            try {
                // console.log("treatment :  ",  treatment);
                const res = await get(`/loadEvaluationsByTreatmentId/station_id=${ station.Id}/treatment_id=${treatment.treatmentID === null ? '' : treatment.treatmentID}/dt=` + Date.now())   
                // console.log("evaluations list: >>>>>>>>>>>>> ", res);
                // console.log("evaluations BestEvaluationId: >>>>>>>>>>>>> ", res[0].BestEvaluationId);
                if( res !== undefined && res.length > 0) {
                    setTreatmentEvaluations(res);
                    setEvaluationMaxGrade(res[0].MaxGrade);
                    setBestEvaluationNum(res[0].BestEvaluationId);
                    setBestEvaluationBy(res[0].BestEvaluationPerformedBy);
                    setTreatmentIsDisqualified(res[0].TreatmentIsDisqualified);
                    setTreatDisqualCreateDate(res[0].TreatDisqualCreateDate);
                    setStationField({Id: res[0].FieldId, Name: res[0].FieldName});
                }           
            }
            catch (error) {
                console.log("Error in loadEvaluationsByTreatmentId >> ", error.message);
            } 
        })();
    }, [treatment.treatmentID, bestEvaluationNum, bestEvaluationBy, treatmentIsDisqualified])
      
    
    useEffect(() => {
        if (treatmentEvaluations.length > 0)
        {
            let temp = [];
            treatmentEvaluations.map((evaluation) => {                      
                temp.push ({
                    ...evaluation,
                    sheetID: evaluation.EvaluationId,
                    sheetType: evaluation.EvaluationType,
                    sheetStatus: evaluation.EvaluationStatus,
                    gradeColor: 
                        evaluation.EvaluationGrade === 0
                        ? "#CCCCCC"    // "status-unknown"
                        : (evaluation.EvaluationGrade > 0 && evaluation.EvaluationGrade < 35) 
                            ? "#ffc3a1" 
                            :  (evaluation.EvaluationGrade >= 35 && evaluation.EvaluationGrade < 80) 
                                ? "lightyellow" : "#bed3be",
                    evaluationGrade: evaluation.EvaluationGrade,
                    evaluationProgress: evaluation.EvaluationProgress,
                    evaluationYear: evaluation.EvaluationYear,
                    createDate: evaluation.EvaluationCreateDate,
                    treatmentId: evaluation.TreatmentId,
                    treatmentStatus: evaluation.TreatmentStatus,
                    treatmentYear: evaluation.TreatmentYear, 
                    sheetColor:
                        evaluation.EvaluationType === 2
                        ? "#ffc3a1"                    
                        : evaluation.EvaluationStatus === 5 
                            ? "#bed3be"      // "accent-1"
                            : (evaluation.EvaluationStatus === 4)
                                ? "#f2e394"    // "accent-4"
                                : "#CCCCCC",    // "status-unknown",
                    sheetName:
                        evaluation.EvaluationCreateDate !== null ? convertDateToDisplayformat(evaluation.EvaluationCreateDate) : "new evaluation",  // only first evaluation for the seedling
                    sheetFontColor:
                        evaluation.EvaluationType === 2
                        ? "#f55d07"
                        : evaluation.EvaluationStatus === 5 
                            ? "#436343"      // "accent-1"
                            : evaluation.EvaluationStatus === 4 
                                ? "#8b8000"    // "accent-4"
                                : "#666666",    // "status-unknown",                                                             
                })                      
            });
            setSheetColor(temp);
        }
    }, [treatmentEvaluations]);
    // console.log('sheetColor >> ', sheetColor);

    
    // hides the "Confirm" popup window 
    const onCloseConfirmWindow = () => {
      setShowConfirmPopup(false);
    };

    // opens a confirm popup window when the "edit" button or select best evaluation radiobutton is clicked
    const openConfirmWindow = (msg, func) => {
        setConfirmMessage(msg);
        setConfirmFuncOnConfirm(() => func); // Store the callback function without executing it        
        setShowConfirmPopup(true);
    };

    // hides the "Confirm" popup window 
    const closeConfirmWindow = () => {
        setShowConfirmPopup(false);
        setConfirmMessage('');    
    };

    // fires when the "Confirm" button is clicked in the "Confirm" popup
    const onConfirm = (evaluation) => {
        if (typeof confirmFuncOnConfirm === 'function') {
            confirmFuncOnConfirm();
        }       

        closeConfirmWindow();
        setConfirmFuncOnConfirm('');
        setSelectedEvaluation(null);
    };    

    // opens a popup window when the "disqualify" button is clicked
    const openDangerPopupWindow = (msg, func) => {
        setDangerMessage(msg);
        
        // fires when the "Yes" button is clicked in the "Danger" popup
        setDangerFuncOnConfirm(() => func); // Store the callback function without executing it        
        setDangerPopupOpen(true);
    };

    // hides the "Danger" popup window 
    const onDangerPopupClose = () => {
        setDangerPopupOpen(false);
        setDangerMessage('');    
    };

    // fires when the "Yes" button is clicked in the "Danger" popup
    const onDangerConfirm = () => {
        // console.log(' << in function onDangerConfirm >> '); 
        if (typeof dangerFuncOnConfirm === 'function') {
            dangerFuncOnConfirm();
        } 
        onDangerPopupClose();
        setDangerFuncOnConfirm('');
    };    

    // opens a popup window when the "edit" button is clicked
    const editSubmittedEv = (evaluation) => {
        // console.log('evaluation -->', evaluation);
        setSelectedEvaluation(evaluation);
        openConfirmWindow(`You have chosen to edit a submitted sheet.
         This might affect the processing flow. Are you sure you want to proceed?`, () => openEdit(evaluation) );
    };

    /*  Handles setting the best evaluation and opens a confirmation popup if needed
        when radiobutton clicked  **/
    const updateBest = (evaluation) => {
        // console.log('bestEvaluationBy >> ', bestEvaluationBy);

        const isAnotherEvaluation = evaluation.EvaluationId !== bestEvaluationNum;
        const isAutoSelection = bestEvaluationBy === 'auto';

        if (isAnotherEvaluation) {
            if (isAutoSelection) {
                openConfirmWindow(
                    `This action will disable automatic selection of the best evaluation based on the highest grade. Please confirm to proceed.`,
                    () => { updateBestEvaluation(evaluation);
                        handleBestTreatment.updateBestAuto();}
            );
            } else {
                updateBestEvaluation(evaluation);
                handleBestTreatment.updateBestAuto();
            }
        } else {
            if (isAutoSelection) {
                openConfirmWindow(
                    `This action will disable automatic selection of the best evaluation based on the highest grade. Please confirm to proceed.`,
                    () => { updateBestEvaluation(evaluation);
                        handleBestTreatment.updateBestAuto();}
                );
            } else {
                openConfirmWindow(
                    `This action will cancel any manual selection of the best evaluation and switch back to automatically selecting the evaluation with the highest grade.`,
                    () => cancelManualSelectionBestEvaluation(evaluation)
                );
            }
        }
    };

    /*  user cancels manually selection the best evaluation 
        and returns to automatic selection the best evaluation based on the highest grade.  **/
    const cancelManualSelectionBestEvaluation = async (evaluation) => {
        updateBestEvaluation(evaluation);
        updateBestEvaluationAuto(evaluation);
        handleBestTreatment.updateBestAuto();
    };

    /*  This asynchronous function updates the best evaluation for a specific treatment at the station. 
        If the update is successful, the best treatment for this station is checked and also updated as necessary.  **/   
    const updateBestEvaluation = async (data) => {
        //  console.log('data >  ', data);
        //  console.log('bestEvaluationNum >  ', bestEvaluationNum);

        try {
            let updateValues = null;
            if (data.EvaluationId !== bestEvaluationNum) {
                updateValues = {
                    StationId: data.StationId,
                    TreatmentId: data.TreatmentId,
                    EvaluationId: data.EvaluationId,
                    Year: new Date().getFullYear(),
                    PerformedAt: correctTimeZone(new Date()),
                    PerformedBy: currentUser.email,
                };
            } else {
                updateValues = {
                    StationId: data.StationId,
                    TreatmentId: data.TreatmentId,
                    EvaluationId: null,
                    Year: new Date().getFullYear(),
                    PerformedAt: correctTimeZone(new Date()),
                    PerformedBy: 'auto',
                };
                if (bestEvaluationBy === 'auto') {
                    // console.log('bestEvaluationNum auto to manual  ');
                    updateValues.EvaluationId = data.EvaluationId;
                    updateValues.PerformedBy = currentUser.email;
                }
            }

            let response = await post(`/updateBestEvaluationForTreatment/dt=${Date.now()}`, updateValues);
            // console.log('Best evaluation updated by user response.result:', response.result);            
            if (!response.success) {
                throw new Error(`${response.message}`);
            } 

            const updateTreatmentValues = {
                Id: generateSyncId(),
                StationId: station.Id,
                BestTreatmentYear: new Date().getFullYear(),
                // Compute the BestTreatmentId as the highest-graded treatment from VEM_Evaluations.
                BestTreatmentId: 'FFFFFFFF-FFFF-FFFF-FFFF-FFFFFFFFFFFF', 
                BestTreatmentDate: correctTimeZone(new Date()),
                BestTreatmentBy: 'auto',
            };
                
            response = await post(`/updateStationBestTreatment/dt=${Date.now()}`, updateTreatmentValues);
            if (!response.success) {
                throw new Error(`${response.message}`);
            }
            // console.log('treatment updated success response.result:', response.result.BestTreatmentId);
            setBestEvaluationNum(updateValues.EvaluationId);
            setBestTreatmentNum(response.result.BestTreatmentId);
            setBestEvaluationBy(updateValues.PerformedBy);
           
        } catch (error) {
            console.error('🔴 Error in updateBestEvaluation:', error.message);

            // Construct error object
            const errorDetails = {
                error: error,
                parameters: { StationId: data.StationId, TreatmentId: data.TreatmentId, EvaluationId: data.EvaluationId, Year: data.EvaluationYear },
                userName: currentUser.email,
                moduleName: 'EvaluationForTreatment',
                functionName: 'updateBestEvaluation',
            };
            await DBlogError(errorDetails);

        }
    };
    
    const updateBestEvaluationAuto = async(evaluation) => {
        // console.log('station id >>>  ', station.Id);
        // console.log('station >>>  ', station);
        // console.log('treatment id >>>  ', treatmentId);
        try {
            const updateEvalValues = {
                StationId: station.Id,
                TreatmentId: evaluation.TreatmentId,
                // EvaluationId: evaluationId,
                EvaluationId: 'FFFFFFFF-FFFF-FFFF-FFFF-FFFFFFFFFFFF',
                Year: evaluation.Year,
                PerformedAt: correctTimeZone(new Date()),
                PerformedBy: 'auto',
            };

            let response = await post(`/updateBestEvaluationForTreatment/dt=${Date.now()}`, updateEvalValues);
            // console.log('Best evaluation updated auto response.result:', response.result);            

            if (!response.success) {
                throw new Error(`${response.message}`);
            }

            setBestEvaluationNum(updateEvalValues.EvaluationId);
            setBestEvaluationBy(updateEvalValues.PerformedBy);
        } catch (error) {
            console.error('🔴 Error in updateBestEvaluationAuto:', error.message);

            // Construct error object
            const errorDetails = {
                error: error,
                parameters: { StationId: evaluation.StationId, TreatmentId: evaluation.TreatmentId, EvaluationId: evaluation.EvaluationId, Year: evaluation.EvaluationYear },
                userName: currentUser.email,
                moduleName: 'EvaluationForTreatment',
                functionName: 'updateBestEvaluationAuto',
            };
            await DBlogError(errorDetails);

        }
    };

    // Function to handle confirmation in the danger popup window
    const doUnDisqualify = async () => {
        setDisqualYear(null);
        await unDisqualify();
        handleBestTreatment.updateBestAuto();
    };

    const unDisqualify = async () => {
        const SQLparams = {
            SeedlingId: null,
            TreatmentId:  treatment.treatmentID,
            StationId: station.Id,
            Year: new Date().getFullYear(),
        };
        const res = await deleteDisqualReason(SQLparams);
        // console.log('treatmentIsDisqualified before deleteDisqualReason >> ', treatmentIsDisqualified);
        // console.log('res from deleteDisqualReason >> ', res);
        if (res === 1) {
            setTreatmentIsDisqualified(0);
            props.loadAllTreatmentsByStation();
        }
    };

    let disable = false; 

    const openEvaluation = async (evaluation) => 
    {
        // console.log('evaluation>> ', evaluation);
        if (evaluation.EvaluationType === 2) {
            setShowDisqualificationReason(true);
            setDisqualYear(new Date(evaluation.EvaluationCreateDate).getFullYear());
            return;
        }

        // console.log('evaluation>> ', evaluation);
        disable = false;
        if (evaluation.sheetStatus === 5 ) 
            disable = true;
        openSheet(evaluation);
    }

    const openEdit = (evaluation) => 
    {
        disable = false;
        openSheet(evaluation);
    }   

    // console.log("selectedEvaluation >> ", selectedEvaluation);
    const openSheet = (evaluation) => {
        // console.log('evaluation >> ', evaluation);
        // console.log("treatmentId >> ", treatment);
        // console.log("evaluation.treatmentId >> ", evaluation.treatmentId);
        
        // console.log("station >> ", station); 
        // console.log(' <<--in OpenSheet f-n --->> ');
        // console.log('evaluation >> ', evaluation); 
        // console.log("seedlingRow >> ", seedlingRow); 
        // console.log("In SeedlingOnField selectedField >> ", selectedField); 

        if ((evaluation.sheetID === null))
            navigate("/preharvest", {
                state: {
                    plantInfo: null,
                    treatmentId: treatment.treatmentID === 0 ? null : treatment.treatmentID,
                    station: station,
                    seedlingId: '',
                    seedlingYear: '',
                    seedlingRow: '',
                    seedlingsArr: [],
                    selectedStation: station, 
                    editMode: false,
                    editYear: true,
                    disable: disable,
                    sheetName: "TREATMENT EVALUATION DATA",
                    preharvestID: evaluation.sheetID,
                    showTreatments: true,
                    showEvaluationForTreatment: true,
                    showTreatmentsMultiYearSummary: false,
                },
            });
        else {
            navigate("/preharvest", {
                state: {
                    plantInfo: null,
                    treatmentId: evaluation.treatmentId === 0 ? null : evaluation.treatmentId,
                    station: station,
                    seedlingId: '',
                    seedlingYear: '',                            
                    seedlingRow: '',
                    seedlingsArr: [],
                    selectedStation: station,                 
                    editMode: true,
                    disable: disable,
                    sheetName: "TREATMENT EVALUATION DATA",
                    preharvestID: evaluation.sheetID,
                    showTreatments: true,
                    showEvaluationForTreatment: true,
                    showTreatmentsMultiYearSummary: false,
                },
        });
        }
    }

    const getBoxWidth = (el, sheetColor) => {
        const currentYear = new Date().getFullYear();
        const lastSheetColor = sheetColor[sheetColor.length - 1]?.evaluationYear;
      
        const isCurrentYearEval = el.EvaluationType === 2 && el.evaluationYear === currentYear;
        const isPreviousYearEval = el.EvaluationType === 2 && el.evaluationYear < currentYear;
        const hasValidSheetColor = lastSheetColor !== null;
      
        return (isCurrentYearEval && hasValidSheetColor) || (isPreviousYearEval && hasValidSheetColor)
          ? "50px"
          : "0px";
    };

    let bg = "#bed3be";
    if (treatmentIsDisqualified === 1)
        bg = "#ffc3a1";

    
    const style = {
        border: "2px solid",
        margin: "10px",
    };
    // console.log('sheetColor >> ', sheetColor);

    return (
        <Box
            id="evals-for-treat"
            ref={modalRef}
            tabIndex="-1"
            style={style}
            direction="row"
            align="start"
            background={bg}>
            {showConfirmPopup && (
                <ConfirmPopupWindow
                    msg={confirmMessage}
                    onClose={onCloseConfirmWindow}
                    onConfirm={onConfirm}
                />
            )}           
            {dangerPopupOpen && (
            <DangerPopupWindow
                msg={dangerMessage}
                onClose={onDangerPopupClose}
                onConfirm={onDangerConfirm}
            />
            )} 
            {showDisqualificationReason &&  
            <DisqualificationReason 
                plant = {null}
                station={station} 
                treatment={treatment}
                updatePlantStatus = {updatePlantStatus}
                reRenderSourseScreen={() => {
                    setTreatmentIsDisqualified(1);
                    props.loadAllTreatmentsByStation();}}
                onClose={() => {
                    setShowDisqualificationReason(false);
                    if (treatment.treatmentID === handleBestTreatment.bestNum && handleBestTreatment.bestBy !== 'auto')
                        handleBestTreatment.cancelManualSelectionOfBest(treatment);
                    handleBestTreatment.updateBestAuto();}}
                disqualYear={new Date().getFullYear()}
                disable={false}
                />
            }

            {/* left side  */}          
            <Box position="relative"> 
                <Box width="140px">
                    <Image
                        size="contain"
                        src="SeedlingIcon.png" 
                        width="100px"                                    
                        height="100px"                                
                    />             
                </Box>
                {(bestEvaluationBy === 'auto' )
                ?  (<Box  align="center" height="100px" pad={{vertical: "medium"}}>
                    <Cycle  color="#436343" size='large' />                                
                   </Box> )
                : (bestEvaluationBy === null )
                ? (<Box  align="center" height="100px" pad={{vertical: "medium"}}> </Box>)
                : (<Box  align="center" height="100px" pad={{vertical: "medium"}}>
                    <UserExpert  color="#436343" size='large' />                                
                </Box> )            
            }                
            </Box> 
            {/* end of the left side  */}
            <Box  
                background="light-3"            
                width= "100%"
                height="100%"
                pad="xsmall" 
                >
                {/* data about station */}
                <Box pad={{vertical: "small"}} align="center">
                    <Box pad={{horizontal: "xsmall"}} direction="row-responsive">
                        <Box direction="row" >
                            <Text weight="bold" margin={{ horizontal: "xsmall" }} size="medium">
                                {treatment.treatmentName.replace(/treatment/gi, "").trim()}
                            </Text>
                            <Text margin={{horizontal: "xsmall"}} size="medium" > treatment</Text>                            
                            <Text margin={{horizontal: "xsmall"}} size="medium" > On Station:</Text>
                            <Text weight="bold" margin={{horizontal: "xsmall"}} size="medium" > {station.Name} </Text>
                        </Box>
                    </Box>            
                    <Box pad={{horizontal: "xsmall"}} direction="row-responsive">
                        <Box pad={{horizontal: "xsmall"}} direction="row">
                            <Box direction="row" >
                                <Text margin={{horizontal: "xsmall"}} size="medium"> On: </Text>  
                                <Text weight="bold" margin={{horizontal: "xsmall"}} size="medium"> {stationField.Name} </Text> 
                            </Box>

                        </Box>
                        <Box pad={{horizontal: "xsmall"}} direction="row">
                            <Box direction="row">
                                <Text margin={{horizontal: "xsmall"}} size="medium" > starts from row:</Text>
                                <Text weight="bold" margin={{horizontal: "xsmall"}} size="medium" > {stationStartRow} </Text>
                            </Box>                    
                        </Box>
                    </Box>
                </Box>
                {/* end of data about station */}
                <Box background="neutral-3" height="2px" margin={{vertical: "small"}}> </Box>

                <Box pad={{vertical: "small"}} align="start"  background="light-4"  direction="row-responsive" justify="around">
                    <Box pad={{horizontal: "xsmall"}} direction="column" >
                        <Box >
                            <Text weight="bold" margin={{vertical: "xsmall"}} size="medium" > Evaluation: </Text>
                        </Box>
                        <Box direction="row" pad={{vertical: "xxsmall"}}  >                                             
                            <Box pad="xxsmall" width= "40px" background="#f2e394" margin="xxsmall" align="center" round={true}> </Box>
                            <Text margin={{horizontal: "xsmall"}} size="medium" > In Progress </Text>
                        </Box>                         
                        
                        <Box direction="row" pad={{vertical: "xxsmall"}}  >
                            <Box pad="xxsmall" width= "40px" background="#bed3be" margin="xxsmall" align="center" round={true}> </Box>
                            <Text margin={{horizontal: "xsmall"}} size="medium" > Finished </Text>
                        </Box>

                        <Box direction="row" pad={{vertical: "xxsmall"}}  >
                            <Box pad="xxsmall" width= "40px" background="#ffc3a1" margin="xxsmall" align="center" round={true}> </Box>
                            <Text margin={{horizontal: "xsmall"}} size="medium" > Disqualified </Text>
                        </Box>                        
                    </Box>  

                    <Box pad={{horizontal: "xsmall"}} direction="column" >
                        <Box >
                            <Text weight="bold" margin={{vertical: "xxsmall"}} size="medium" > Grades: </Text>
                        </Box>

                        <Box direction="column"  >
                            <Box direction="row"  align="center">
                                <Box pad="xxsmall" width= "30px" background="#ffc3a1" margin="xxsmall" align="center" round={true}>
                                    <Text  size="small" 
                                        fill="horizontal"
                                        // margin={{horizontal: "xsmall"}} 
                                        weight="bold" >{25}
                                    </Text>                                                  
                                </Box>
                                <Text  margin={{horizontal: "xsmall"}} size="medium" > grade  &lt; 35 </Text>                         
                            </Box>                    

                            <Box direction="row" align="center" >
                                <Box pad="xxsmall" width= "30px" background="lightyellow" margin="xxsmall" align="center" round={true}>
                                    <Text  size="small" 
                                        fill="horizontal"
                                        // margin={{horizontal: "xsmall"}} 
                                        weight="bold" >{40}
                                    </Text>
                                </Box>
                                <Text  margin={{horizontal: "xsmall"}} size="medium" > 35 &le; grade  &lt; 80 </Text>                         
                            </Box>   

                            <Box direction="row" align="center" >
                                <Box pad="xxsmall" width= "30px" background="#bed3be" margin="xxsmall" align="center" round={true}>
                                    <Text  size="small" 
                                        fill="horizontal"
                                        // margin={{horizontal: "xsmall"}} 
                                        weight="bold" > {85}
                                    </Text>
                                </Box>                    
                                <Text  margin={{horizontal: "xsmall"}} size="medium" > grade  &ge; 80 </Text>                         
                            </Box>                  
                        </Box>
                    </Box> 
                </Box>



                <Box pad={{vertical: "small"}} align="center"  background="light-4"  direction="row-responsive" justify="around">
                    <Box pad={{horizontal: "xsmall"}} direction="column" >
                        <Box >
                            <Text weight="bold" margin={{vertical: "xxsmall"}} size="medium" > Best Evaluation selected: </Text>
                        </Box>

                        <Box direction="row-responsive"  justify="around">
                            <Box direction="row"  pad="xxsmall" >
                                <UserExpert  color="#436343" size='20px' />
                                <Text  margin={{horizontal: "xsmall"}} size="medium" > manually </Text>
                            </Box>                       
                            
                            <Box direction="row"    pad="xxsmall" >
                                <Cycle  color="#436343" size='20px' />
                                <Text  margin={{horizontal: "xsmall"}} size="medium" > automatic calc-n </Text>
                            </Box> 
                        </Box>
                    </Box>                                           
                </Box> 

                <Box background="neutral-3" height="3px" margin={{vertical: "small"}}> </Box>
                {/* list of evaluations buttons */}
                <Box align="center">
                    <Box pad={{vertical: "xxsmall"}} >
                        {sheetColor.length > 0 && sheetColor.map (el => 
                        <Box align="center"
                            direction="row-responsive"
                            key={(el.sheetID)}
                            >

                            <Box direction="row"  >  
                            {(el.sheetType !== 2 && el.evaluationYear !== null) ? (     
                                    <>
                                    <Box direction="row" width= "20px" pad={{horizontal: "xxsmall"}} margin='xsmall'>  
                                        {(bestEvaluationNum !== null && el.sheetID === bestEvaluationNum) &&
                                        <Trophy weight="bold" color="#047343"  size= "18px"/>}                                                                                             
                                    </Box> 

                                    <RadioButton
                                        name="radio"
                                        hoverIndicator
                                        border={{ color: "red", size: "small" }}                                    
                                        style={{color: "red", accentColor: "red"}}
                                        checked={bestEvaluationNum !== null && el.sheetID === bestEvaluationNum}
                                        onChange={() => {}}
                                        onClick={() => updateBest(el)}
                                    />
                                </>)
                                    :
                                        <Box width={getBoxWidth(el, sheetColor)} />                                     
                                }

                                <Box pad={{horizontal: "xxsmall"}} width={sheetColor.length > 1 ? "150px" : "160px"}>
                                    <SheetStateButton evaluationMaxGrade={evaluationMaxGrade} el={el} openSheet={openEvaluation} />                             
                                </Box>                            
                            </Box> 
                            {(el.sheetType !== 2 && el.evaluationYear !== null) ? (
                            <Box pad={{horizontal: "xxsmall"}} direction="row"  align="center" > 
                                <OpenSummaryButton evaluationMaxGrade={evaluationMaxGrade} el={el} 
                                            showEvaluationSummary = {setShowEvaluationSummary} 
                                            setSelectedEvaluation = {setSelectedEvaluation} />                        
                            
                                {/* evaluation finished */}
                                {el.sheetStatus === 5  && (
                                    <Box pad={{horizontal: "xxsmall"}} width= "110px" >
                                    <Box  margin="xxsmall">
                                        <Button                           
                                            color="#f0869c"
                                            style={{color: "#ffffff", padding: 0, fontSize: "16px"}}
                                            primary
                                            // label={plant.Id}
                                            label="edit"
                                            onClick={() =>  editSubmittedEv(el)}
                                        />
                                        </Box>  
                                    </Box>                                
                                )}

                                {/* evaluation not finished  display evaluation progress*/}
                                {((el.sheetStatus === 3) || (el.sheetStatus === 4 )) && (
                                <Box pad={{horizontal: "xxsmall"}}  width= "110px" >
                                    <Box  margin="xxsmall" align="center" round={true} 
                                        background={
                                            `radial-gradient(circle farthest-corner at 0% 50%, #bed3be ${el.evaluationProgress === 100 ? el.evaluationProgress : el.evaluationProgress-10}%, #f8facd ${el.evaluationProgress}%, #f2e394 100%)`
                                        }>
                                        <Text 
                                            fill="horizontal"
                                            weight="bold" > {Math.round(el.evaluationProgress)} %
                                        </Text>
                                    </Box>
                                </Box>                                
                                )}                                
                            </Box> 
                            )
                            : (el.sheetType === 2 && el.evaluationYear === new Date().getFullYear()) 
                            ?
                            <Box pad={{horizontal: "xxsmall"}} direction="row"  align="center" margin={{horizontal: "xxsmall"}}>
                            <IconTooltipButton
                                doOnClick={() =>  
                                    openDangerPopupWindow("This action will permanently remove the disqualification record. Are you sure you want to proceed?"
                                    , doUnDisqualify)}                                 
                                iconName = "Like"
                                iconColor = "#ffc3a1"
                                borderColor='#f55d07'
                                size="34px" 
                                tip="Remove Disqualified Status"
                                />                                                
                            </Box>
                            : 
                            <Box></Box>                        
                        }
                        </Box>                                            
                        )}

                        {showEvaluationSummary &&
                        <Box>
                            <EvaluationSummary plant={null} station={station} treatment={treatment} setPlantInfo={props.setPlantInfo} 
                                setShowEvaluationSummary={setShowEvaluationSummary}
                                evaluation={(selectedEvaluation.sheetID)}
                            />
                        </Box>
                        }                         

                        {/* was changed to allow adding evaluation even after treatment was complete  */}
                        {(sheetColor[sheetColor.length-1].sheetStatus === 5 ) && (
                            <Box  align="center" >
                                <Box pad="xxsmall" width= "160px" margin={{vertical: "xxsmall"}} >
                                <Button                        
                                    color="status-unknown"
                                    style={{padding: '2px', color: '#666666'}}
                                    primary
                                    label="new evaluation"
                                    // onClick={() => OpenNew(sheetColor[sheetColor.length-1])}
                                    onClick={() => openEvaluation(initEvaluationColorState()[0])}
                                />
                                </Box> 
                            </Box>
                        )} 

                    </Box>
                    {!(treatmentIsDisqualified === 1) && (
                        <Box  align="center" >
                            <Box pad="xxsmall" width= "160px" margin={{vertical: "xxsmall"}} >
                            <Button
                                color="#ffc3a1" 
                                primary
                                label="disqualify" 
                                style={{padding: 0, color: 'red'}}
                                onClick={() => {
                                setShowDisqualificationReason(true);
                                setDisqualYear(new Date().getFullYear());}}
                            />                                  
                            </Box> 
                        </Box>
                    )}
                    <Box pad={{vertical: "xxsmall"}} >

                    </Box>
                </Box>
                {/* end of buttons of evaluations */}
                <Box  pad="xxsmall" align="center" justify="between">
                        <Button label="close" 
                            style={{color: "#ffffff", padding: "0px", width: "150px"}}
                            primary onClick={() => props.setShow(false)} 
                        />   
                </Box>              
            </Box>               
        </Box>
    );
};

export default EvaluationForTreatment;
